import type { FC } from 'react';
import { type DialogPopupType } from '../types/propsType';
import styles from './SubComponent.module.scss';

const Dialog: FC<DialogPopupType> = ({ children }) => <section className={styles['dialog-popup']}>{children}</section>;

export default Dialog;
